module.exports = __webpack_public_path__ + "static/img/award1.e9a5303.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award1.png
// module id = L5ry
// module chunks = 7